import * as React from 'react';
import { observer } from 'mobx-react';
import { getExternalAnsweredQuestionnaireById } from '../questionnaireApi';
import NotFoundPage from '../../error/NotFoundPage';
import AnsweredQuestionnaire from '../../../components/questionnaire/answeredQuestionnaire/AnsweredQuestionnaire';
import { withAnsweredQuestionnaire } from '../../../router/Loaders';

interface Props {
  questionnaireId: number;
  renderSearch: (showSearch: boolean) => void;
}

@observer
class ExternalHistory extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props);
    this.props.renderSearch(false);
  }

  public render() {
    return (
      <>
        {
          withAnsweredQuestionnaire(
            () => getExternalAnsweredQuestionnaireById(this.props.questionnaireId),
            answeredQuestionnaire =>
              <AnsweredQuestionnaire
                enableComment={false}
                questionnaireId={this.props.questionnaireId}
                answeredQuestionnaire={answeredQuestionnaire}
                errorPage={<NotFoundPage/>}/>
          )
        }
      </>
    );
  }

}

export default ExternalHistory;
